import { render, staticRenderFns } from "./OsSheetHeader.vue?vue&type=template&id=b018bfb8&scoped=true"
import script from "./OsSheetHeader.vue?vue&type=script&lang=ts"
export * from "./OsSheetHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b018bfb8",
  null
  
)

export default component.exports